module.exports = __webpack_public_path__ + "static/2nd-tpm-3-e64b52bd82bdeceb068b288638c24bf0.jpg";